<script>
export default {

  props: {

    model: {
      type: String,
      required: true
    }

  }

}
</script>

<template>
  <a-entity :gltf-model="'#' + model" />
</template>
